module.exports = __webpack_public_path__ + "static/media/day.7f93fbdb.svg";